<template>
	<el-dialog :title="'项目基础设置 '" :close-on-click-modal="false" :visible.sync="visible" width="590px"
		class="project-kind-dialog" :append-to-body="true">
		<el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="170px" :inline="true"
			class="compact-form">
			<el-form-item label="项目工作控制号" prop="workNo" class="item">
				<el-input v-model="dataForm.workNo" readOnly class="uniform-input"></el-input>
			</el-form-item>
			<el-form-item label="项目名称" prop="projectName" class="item">
				<el-tooltip effect="dark" :content="dataForm.projectName" placement="top-start"
					:disabled="!dataForm.projectName || dataForm.projectName.length <= 20">
					<el-input v-model="dataForm.projectName" readOnly class="uniform-input text-ellipsis"></el-input>
				</el-tooltip>
			</el-form-item>
			<el-form-item label="项目执行遵循程序文件" prop="executedFile" class="item">
				<el-select v-model="dataForm.executedFile" placeholder="请选择" class="uniform-select" clearable
					@blur="handleExecutedFileBlur" @change="handleExecutedFileChange">
					<el-option v-for="item in executedFileList" :key="item.value" :label="item.label"
						:value="item.value">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="项目简称" prop="projectOtherName" class="item">
				<el-input v-model="dataForm.projectOtherName" placeholder="请输入内容" clearable
					class="uniform-input"></el-input>
			</el-form-item>
			<el-form-item label="委托单位" prop="projectEntrust" class="item">
				<el-input v-model="dataForm.projectEntrust" placeholder="请输入内容" clearable
					class="uniform-input"></el-input>
			</el-form-item>
			<el-form-item label="承包单位" prop="contractCompany" class="item">
				<el-input v-model="dataForm.contractCompany" placeholder="请输入内容" clearable
					class="uniform-input"></el-input>
			</el-form-item>
			<el-form-item label="建造单位" prop="projectConstructionCompany" class="item">
				<el-input v-model="dataForm.projectConstructionCompany" placeholder="请输入内容" clearable
					class="uniform-input"></el-input>
			</el-form-item>
			<el-form-item label="设计单位" prop="projectDesignCompany" class="item">
				<el-input v-model="dataForm.projectDesignCompany" placeholder="请输入内容" clearable
					class="uniform-input"></el-input>
			</el-form-item>
			<!-- <el-form-item label="Logo" prop="logoPath" class="item">
				<div class="addImgBox" v-if="dataForm.logoPathUrl">
					<el-image style="width: 100%; height: 100%" :src="dataForm.logoPathUrl" fit="cover"></el-image>
					<div class="delBox">
						<i class="el-icon-delete" @click="delImg()"></i>
					</div>
				</div>
				<el-upload v-if="!dataForm.logoPath" class="addImgBox" ref="uploadImg" :action="action"
					:http-request="uploadImg" accept="image/jpeg,image/png,image/jpg">
					<el-image style="width: 100%; height: 100%" :src="addImg" fit="cover">
					</el-image>
				</el-upload>
			</el-form-item> -->
			<el-form-item label="公司logo" prop="logoId" class="item">
				<el-select v-model="dataForm.logoId" placeholder="请选择" class="uniform-select" clearable>
					<el-option v-for="item in logoList" :key="item.recNo" :label="item.logoName"
						:value="item.recNo">
					</el-option>
				</el-select>
			</el-form-item>
		</el-form>
		<el-row class="formBtnGroup">
			<el-button v-preventReClick class="btn" type="primary" size="small" @click="dataFormSubmit()">保存</el-button>
			<el-button v-preventReClick class="rebtn" size="small" @click="visible = false">取消</el-button>
		</el-row>
		<set-subject v-if="setSubjectVisible" ref="setSubject"></set-subject>
	</el-dialog>
</template>

<script>
import $common from "@/utils/common.js"
import addImg from "@/assets/images/addImg.png"
import SetSubject from './subjectList-add-or-update.vue'
export default {
	name: "project-kind-setting",
	data() {
		return {
			action: "",
			addImg: addImg,
			visible: false,
			inline: false,
			setSubjectVisible: false,
			operateType: '',
			executedFileList: [
				{
					value: '2',
					label: 'CCSI-MP PM03(Rev1.0)船舶监造 监理管理程序'
				},
				{
					value: '1',
					label: 'SHDH-QHSE WG802_工程设备监理工作须知_D.2'
				},
				
			],
			logoList: [],
			dataForm: {
				workNo: '',
				projectName: '',
				projectOtherName: '',
				contractCompany: '',
				projectEntrust: '',
				projectConstructionCompany: '',
				projectDesignCompany: '',
				executedFile: '',
				// logoPath: '',
				// logoPathUrl: '',
				logoId: '',
			},
			dataRule: {
				executedFile: [
					{ required: true, message: "请选择项目执行遵循程序文件", trigger: ["blur"] }
				],
				logoId: [
					{ required: true, message: "请选择公司logo", trigger: ["blur"] }
				],
			},
		}
	},
	mounted() {
	},
	components: {
		SetSubject
	},
	methods: {
		init(type) {
			this.visible = true;
			if (this.$refs["dataForm"]) {
				this.$refs["dataForm"].resetFields()
			}
			this.operateType = type
			this.dataForm = {
				workNo: $common.getItem("workNo"),
				projectName: '',
				projectOtherName: '',
				contractCompany: '',
				projectEntrust: '',
				projectConstructionCompany: '',
				projectDesignCompany: '',
				executedFile: '',
				// logoPath: '',
				// logoPathUrl: '',
				logoId: '',
			},
				this.$nextTick(() => {
					this.$http({
						url: this.$store.state.httpUrl + "/index/infoName/" + $common.getItem("workNo"),
						method: "get",
						params: {},
					}).then(({ data }) => {
						if (data && data.resultCode === 200) {
							this.dataForm = data.body
							this.getProjectLogoSetList();
						}
					});
				});
		},
		// 表单提交
		dataFormSubmit() {
			this.$refs["dataForm"].validate(valid => {
				if (valid) {
					this.$http({
						url: this.$store.state.httpUrl +
							`/business/projectsupervisorinfo/updateProjectSupervisor`,
						method: "post",
						data: this.$http.adornData(this.dataForm)
					}).then(({ data }) => {
						if (data && data.resultCode === 200) {
							this.$message({
								message: "操作成功",
								type: "success",
								duration: 1500,
								onClose: () => {
									this.visible = false;
									//  若是从项目列表页跳出此dialog，需要接着判断时候已经设置了标的物信息
									if (this.operateType == '1') {
										this.$http({
											url: this.$store.state.httpUrl + "/common/validProject/" + this.dataForm.workNo,
											method: "get",
											params: {},
										}).then(({ data }) => {
											if (data && data.resultCode === 200) {
												if (data.body.validResult == '2') {
													sessionStorage.setItem('workNo', JSON.stringify(this.dataForm.workNo))
													this.setSubjectVisible = true
													this.$nextTick(() => {
														this.$refs.setSubject.init(null, '1')
													})
												} else {
													sessionStorage.setItem('workNo', JSON.stringify(this.dataForm.workNo))

													$common.setItem('menuList', data.body.menuList);
													$common.setItem('permissions', data.body.permissions);
													this.setMenuIndex(data.body.menuList);

													// 一级权限菜单定位到第一个
													sessionStorage.setItem('menuIndex', 0)
													sessionStorage.setItem('subMenuIndex', 0)
													this.$cookie.set('showSidebarFlag', false)
													this.getSubjectDropDown();
													this.$router.push({ name: 'workbench' }).catch(err => {
													})
													// location.reload()
												}
											}
										});
									}
								}
							});
						}
					});
				}
			});
		},
		setMenuIndex(menuList) {
			var _href = window.location.href;
			var _routerName = _href.substr(_href.indexOf("#/") + 2);
			if (_href.indexOf("?") > 0) {
				_routerName = _routerName.substr(0, _routerName.indexOf("?"));
			}
			let _index = 0;
			let _subIndex = 0;

			menuList.forEach((item, index) => {
				item.list.forEach((subItem, subIndex) => {
					if (subItem.routerName == _routerName) {
						_index = index;
						_subIndex = subIndex;
					}
				})
			})
			$common.setItem('menuIndex', _index);
			$common.setItem('subMenuIndex', _subIndex);
		},
		getSubjectDropDown() {
			this.$http({
				url: this.$store.state.httpUrl + "/common/getSubjectDropDown/" + $common.getItem("workNo"),
				method: "get",
				params: {},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.subjectList = data.body;
					this.$store.commit('common/updateSubjectList', this.subjectList)
					if (this.subjectList.length != undefined && this.subjectList.length > 0) {
						if ($common.getItem("subjectNo") == "" || $common.getItem("subjectNo") == undefined) {
							$common.setItem("subjectNo", this.subjectList[0].displayValue);
							this.$store.commit('common/updateSelectSubjectNo', this.subjectNo)
						}
					}
				}
				this.$router.push({ name: 'workbench' }).catch(err => {
				})
			});
		},
		getProjectLogoSetList() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/projectlogoset/list",
				method: "get",
				params: {},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.logoList = data.body;
				}
			});
		},
		handleExecutedFileBlur() {
			// 失焦时仅当值为空才触发校验
			if (!this.dataForm.executedFile) {
				this.$refs.dataForm.validateField('executedFile');
			}
		},
		handleExecutedFileChange() {
			// 选择值后清除校验提示
			this.$refs.dataForm.clearValidate('executedFile');
		},
		// uploadImg(param) {
		// 	const formData = new FormData();
		// 	formData.append('file', param.file);
		// 	this.$refs.uploadImg.clearFiles();
		// 	this.$http.post(
		// 		this.$store.state.httpUrl + "/file/upload/" + $common.getItem("workNo") + "/10/0",
		// 		formData,
		// 		{
		// 			headers: { 'Content-Type': 'multipart/form-data' }
		// 		},
		// 	).then(res => {
		// 		res = res.data
		// 		if (res.resultCode == 200) {
		// 			this.dataForm.logoPath = res.body.fileSavePath;
		// 			this.dataForm.logoPathUrl = res.body.fileUri;
		// 		} else {
		// 			this.$message.info('文件上传失败')
		// 		}
		// 	})
		// },
		// delImg() {
		// 	this.dataForm.logoPath = ''
		// 	this.dataForm.logoPathUrl = ''
		// },
	}
}
</script>
<style scoped>
/* 减小对话框标题区域高度 */
.project-kind-dialog>>>.el-dialog__header {
	padding: 12px 20px 10px;
}

.project-kind-dialog>>>.el-dialog__title {
	font-size: 16px;
	line-height: 2.5;
}

/* 减少表单项间距 */
.compact-form .item {
	margin-bottom: 16px;
}

/* 统一输入框和下拉框的样式 */
.uniform-input,
.uniform-select {
	width: 320px !important;
	font-size: 13px !important;
}

.uniform-input>>>.el-input__inner,
.uniform-select>>>.el-input__inner {
	height: 32px;
	line-height: 32px;
	font-size: 13px;
	padding: 0 10px;
}

/* 新增：下拉框箭头垂直居中 */
.uniform-select>>>.el-input__suffix {
	display: flex;
	align-items: center;
	height: 100%;
}

.uniform-select>>>.el-input__suffix-inner {
	height: 100%;
	display: flex;
	align-items: center;
}

.uniform-select>>>.el-select__caret {
	line-height: 32px;
}

/* 标签样式保持原有 */
.item /deep/ .el-form-item__label {
	color: #00428E !important;
	margin-right: 10px !important;
	font-weight: bold !important;
	background-color: #E1F1FF;
	white-space: nowrap !important;
	font-size: 13px;
	height: 32px;
	line-height: 32px;
	padding: 0 12px;
	box-sizing: border-box;
}

/* 调整表单项整体布局 */
.item /deep/ .el-form-item__content {
	line-height: 32px;
}

/* 调整按钮区域上边距 */
.formBtnGroup {
	margin-top: 10px;
	text-align: center;
}

/* 文本溢出省略号 */
.text-ellipsis>>>.el-input__inner {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

/* 下拉框选项字体大小 */
.uniform-select>>>.el-select-dropdown__item {
	font-size: 13px !important;
}

/* 下拉框选中项字体大小（可选，保持一致） */
.uniform-select>>>.el-select-dropdown__item.selected {
	font-size: 13px !important;
}

/* 下拉框容器内所有文字 */
.uniform-select>>>.el-select-dropdown {
	font-size: 13px !important;
}

.addImgBox {
	width: 136px;
	height: 136px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 10px;
	position: relative;
}
</style>